import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEpisodeOverview = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M25.76 13h-.51v-1.58c0-1.07-.87-1.93-1.93-1.93h-.4V7.93c0-1.07-.87-1.93-1.93-1.93H6.93C5.86 6 5 6.87 5 7.93v9.84c0 1.07.87 1.93 1.93 1.93h.4v1.56c0 1.07.87 1.93 1.93 1.93h.51v1.58c0 1.07.87 1.93 1.93 1.93h14.05c1.07 0 1.93-.87 1.93-1.93v-9.84c0-1.07-.87-1.93-1.93-1.93h.01ZM6.93 18.5c-.4 0-.73-.33-.73-.73V7.93c0-.4.33-.73.73-.73h14.05c.4 0 .73.33.73.73v1.56H9.26c-1.07 0-1.93.87-1.93 1.93v7.09h-.4v-.01Zm2.33 3.49c-.4 0-.73-.33-.73-.74v-9.84c0-.41.33-.74.73-.74h14.05c.4 0 .73.33.73.74v1.58H11.71c-1.07 0-1.93.87-1.93 1.93v7.06h-.51l-.01.01Zm17.23 2.78c0 .4-.33.73-.73.73H11.71c-.41 0-.74-.33-.74-.73v-9.84c0-.4.33-.73.74-.73h14.05c.4 0 .73.33.73.73v9.84Z"
	})
});
export { SvgEpisodeOverview as ReactComponent };
